import { CommentSolid } from '@assets/svgs';
import { Badge } from '@components/badge';
import { IconButton } from '@components/iconButton/IconButton';
import { useNavigate } from 'react-router-dom';

export type UnreadMessageNotificationColumnProps = {
  quoteId: string;
  unreadMessageCount?: number;
};

export const UnreadMessageNotificationColumn = ({
  quoteId,
  unreadMessageCount,
}: UnreadMessageNotificationColumnProps) => {
  const navigate = useNavigate();
  const handleOnClick = () => {
    navigate(`/quote/${quoteId}?sidebarItem=messages`);
  };

  const hasUnreadMessages = unreadMessageCount && unreadMessageCount > 0;

  return (
    <IconButton
      variant='circular'
      onClick={handleOnClick}
      disabled={!hasUnreadMessages}
      sx={{
        color: 'secondary.main',
        width: '28px',
        height: '28px',
        padding: 0,
      }}
    >
      {hasUnreadMessages ? (
        <Badge
          badgeContent={unreadMessageCount}
          maxCount={9}
          sx={{
            '& .MuiBadge-badge': {
              height: '14px',
              padding: 0,
              width: '14px',
              right: 0,
              color: 'common.white',
              backgroundColor: 'error.main',
            },
          }}
        >
          <CommentSolid width='16px' height='17px' />
        </Badge>
      ) : (
        <CommentSolid width='16px' height='17px' />
      )}
    </IconButton>
  );
};
